import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IssueService } from '../../issue/services/issue.service';

@Pipe({
  name: 'issueStatus'
})
export class IssueStatusPipe implements PipeTransform {

  constructor(private _issueService: IssueService){

  }

  transform(value: number): Observable<string> {
    if(typeof value !== 'number') return null;
    return this._issueService.getIssueStatusById(value, true).pipe(map(x => x.statename));
  }

}
